import React, { useEffect, useState } from "react";
import axios from "axios";
import { Spin, message } from "antd";
import Footer from "../components/Footer";
import HeroPages from "../components/HeroPages";
import PlanTrip from "../components/PlanTrip";

function About() {
  const [aboutData, setAboutData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchAboutData();
  }, []);

  const fetchAboutData = async () => {
    try {
      const response = await axios.get("http://93.127.203.113:5005/about");
      if (response.data) {
        setAboutData(response.data);
      } else {
        message.warning("No about data found.");
      }
    } catch (error) {
      message.error("Failed to fetch about data.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <section className="about-page">
        <HeroPages name="About" />
        <div className="container">
          {loading ? (
            <div className="loading-container">
              <Spin size="large" />
            </div>
          ) : aboutData ? (
            <div className="about-main">
              {/* About Image */}
              <div className="about-main__img-wrapper">
                <img
                  className="about-main__img"
                  src={`http://93.127.203.113:5005${aboutData.image}`}
                  alt="about-section"
                />
              </div>

              {/* About Text */}
              <div className="about-main__text">
                <h2 className="about-main__title">{aboutData.title}</h2>
                <h3 className="about-main__subtitle">{aboutData.subtitle}</h3>
      
                <p className="about-main__description">{aboutData.description}</p>
              </div>
            </div>
          ) : (
            <p className="no-about-data">No about data available.</p>
          )}

          {/* Plan Trip Section */}
          <PlanTrip />
        </div>
      </section>

      {/* Book Banner */}
      <div className="book-banner">
        <div className="book-banner__overlay"></div>
        <div className="container">
          <div className="book-banner__content">
            <h2>Book a car by getting in touch with us</h2>
            <span className="book-banner__contact">
              <i className="fa-solid fa-phone"></i>
              <h3>251912000101</h3>
            </span>
          </div>
        </div>
      </div>

      <Footer />

      {/* 🌟 Styles for Consistency */}
      <style jsx>{`
        .about-page {
          width: 100%;
          padding: 80px 20px;
          background-color: #f8f9fa;
        }

        .container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 20px;
        }

        .loading-container {
          display: flex;
          justify-content: center;
          align-items: center;
          height: 200px;
        }

        .about-main {
          display: flex;
          gap: 40px;
          align-items: center;
          justify-content: center;
        }

        .about-main__img-wrapper {
          width: 45%;
          border-radius: 10px;
          overflow: hidden;
        }

        .about-main__img {
          width: 100%;
          height: auto;
          border-radius: 10px;
        }

        .about-main__text {
          width: 50%;
        }

        .about-main__subtitle {
          font-size: 1.8rem;
          color: #0c8c49;
          text-transform: uppercase;
          letter-spacing: 2px;
          margin-bottom: 10px;
        }

        .about-main__title {
          font-size: 3rem;
          color: #333;
          margin-bottom: 15px;
        }

        .about-main__description {
          font-size: 1.6rem;
          color: #555;
          line-height: 1.8;
        }

        .book-banner {
          margin-top: 50px;
          padding: 50px 0;
          background: #0c8c49;
          color: white;
          text-align: center;
          position: relative;
        }

        .book-banner__overlay {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(0, 0, 0, 0.3);
        }

        .book-banner__content {
          position: relative;
          z-index: 2;
        }

        .book-banner__contact {
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 15px;
          font-size: 20px;
          font-weight: bold;
        }

        .no-about-data {
          text-align: center;
          font-size: 1.8rem;
          color: #777;
          margin-top: 20px;
        }

        @media (max-width: 1024px) {
          .about-main {
            flex-direction: column;
            text-align: center;
          }

          .about-main__img-wrapper {
            width: 80%;
          }

          .about-main__text {
            width: 80%;
          }
        }

        @media (max-width: 768px) {
          .about-main__title {
            font-size: 2.5rem;
          }

          .about-main__description {
            font-size: 1.5rem;
          }
        }
      `}</style>
    </>
  );
}

export default About;
